import React, { Component, useState } from 'react'
import { arrayOf, object, bool, string } from 'prop-types'
import classnames from 'classnames'
import { startCase } from 'lodash'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import MajorItem from 'components/molecules/MajorItem/MajorItem'

const FacultyMajors = ({ majors, active }) => {
  const initialState = () => majors.map((major, idx) => ({
    ...major,
    active: idx === 0,
    id: idx,
    studyPlans:
  <ol className="major-item__study-plan">
    {
      major.study_plans.map((studyPlan, id) => (
        <li>
          <Typography component="p" variant="subbody" key={`sp-${id}`} className="major-item__sp-name">
            {studyPlan}
          </Typography>
        </li>
      ))
    }
  </ol>,
  }))
  const [majorItem, setMajors] = useState(initialState())

  const toggleMajor = (id) => {
    const newMajors = majorItem.map((major, idx) => (
        idx === id ? { ...major, active: !major.active } : { ...major, active: false }
      )
    )
    setMajors(newMajors)
  }

  return (
    <div className={classnames('faculty-study-program__majors', { hide: !active })}>
      {
        majorItem.map((major, idx) => (
          <MajorItem
            name={major.name}
            studyPlans={major.study_plans}
            active={major.active}
            key={`major-itm-${idx}`}
            onClick={() => toggleMajor(idx)}
          />
        ))
      }
      <style jsx>
        {`
          .faculty-study-program {
            &__majors {
              @media screen and (min-width: 768px) {
                margin-left: 32px;
              }
              &.hide {
                display: none;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

MajorItem.propTypes = {
  name: string,
  study_plans: arrayOf(string),
}

FacultyMajors.propTypes = {
  majors: arrayOf(MajorItem),
  active: bool,
}

class FacultyStudyProgram extends Component {
  state = {
    activeStageIdx: 0,
  }

  getProgramName = (program) => {
    switch (program.toUpperCase()) {
      case 'D1':
        return 'Program Diploma (D1)'
      case 'D2':
        return 'Program Diploma (D2)'
      case 'D3':
        return 'Program Diploma (D3)'
      case 'D4':
        return 'Program Diploma (D4)'
      case 'S1':
        return 'Program Sarjana (S1)'
      case 'S2':
        return 'Program Master (S2)'
      case 'S3':
        return 'Program Doktoral (S3)'
      case 'SPECIALIST':
        return 'Program Spesialis'
      case 'PROFESSION':
        return 'Program Profesi'
      default:
        return startCase(program)
    }
  }

  setActive = (idx) => {
    this.setState({
      activeStageIdx: idx,
    })
  }

  render() {
    const { activeStageIdx } = this.state
    const { majors } = this.props
    const stageKeys = Object.keys(majors).sort()

    return (
      <div className="faculty-study-program">
        <SectionContainer
          paddingTop={80}
        >
          <Container>
            <SectionTitle title="Program Kuliah" />
            <Row>
              <Col md="3">
                <div className="faculty-study-program__stages">
                  {
                    stageKeys.map((stage, idx) => (
                      <div
                        className={
                          classnames('faculty-study-program__stage-item', {
                            active: activeStageIdx === idx,
                          })
                        }
                        onClick={() => this.setActive(idx)}
                        key={`prog-${stage}-${idx}`}
                      >
                        { this.getProgramName(stage)}
                      </div>
                    ))
                  }
                </div>
              </Col>
              <Col md="9">
                {
                  stageKeys.map((stage, idx) => (
                    <FacultyMajors
                      majors={majors[stage]}
                      active={activeStageIdx === idx}
                      key={`fml-${stage}-${idx}`}
                    />
                  ))
                }
              </Col>
            </Row>
          </Container>
        </SectionContainer>
        <style jsx>
          {`
            .faculty-study-program {
              &__stages {
                @media screen and (max-width: 767px) {
                  display: flex;
                  flex-wrap: nowrap;
                  overflow: scroll;
                }
              }
              &__stage-item {
                cursor: pointer;
                padding: 32px 16px;
                font-size: 16px;
                font-weight: bold;
                color: #7d92a9;
                border-top: solid 1px #d3dce6;
                @media screen and (max-width: 767px) {
                  flex-shrink: 0;
                  border-bottom: solid 1px #d3dce6;
                  padding: 24px 16px;
                }
                &:last-of-type {
                  border-bottom: solid 1px #d3dce6;
                }
                &.active, &:hover {
                  color: #0c2846;
                  background-color: #f6f7fa;
                }
              }
            }
          `}
        </style>
      </div>
    )
  }
}

FacultyStudyProgram.propTypes = {
  majors: object,
}

export default FacultyStudyProgram
